module.exports = __webpack_public_path__ + "static/media/fallback.ea82b5b8.png";